import { render, staticRenderFns } from "./IdentificatorField.vue?vue&type=template&id=0f864560&scoped=true&"
import script from "./IdentificatorField.vue?vue&type=script&lang=js&"
export * from "./IdentificatorField.vue?vue&type=script&lang=js&"
import style0 from "./IdentificatorField.vue?vue&type=style&index=0&id=0f864560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f864560",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormLabel: require('/workspace/components/Form/FormLabel.vue').default})
